<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content">
    <div style="background-color: #548235; height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)"
         style="background-color: #a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
        <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">
            {{ isUpdate ? 'Edit' : 'New' }} Image Favorite
        </h5>
    </div>

    <div class="modal-body" style="padding: 15px;">
        <div class="form-group" style="margin-bottom: 12px;">
            <label for="imageFavoriteName">Name*</label>
            <input type="text" id="imageFavoriteName" name="imageFavoriteName" class="form-control" maxlength="256" [(ngModel)]="name" required />
        </div>

        <div class="form-group" style="margin-bottom: 12px;">
            <label for="imageFavoriteDescription">Description</label>
            <input type="text" id="imageFavoriteDescription" name="imageFavoriteDescription" class="form-control" maxlength="1024" [(ngModel)]="description" />
        </div>

        <div class="form-group" style="margin-bottom: 12px;">
            <label>Access Group*</label>
            <ng-select [items]="userGroups" bindLabel="name" bindValue="id" name="userGroupId"
                       placeholder="Select Access Group" [clearable]="false" [(ngModel)]="userGroupId">
            </ng-select>
        </div>

        <div class="form-group" style="margin-bottom: 8px;">
            <label style="display: block;">Background Image*</label>
            <label style="font-weight: 400; margin-right: 16px;">
                <input type="radio" name="imageSourceType" [value]="SourceType.Static" [(ngModel)]="imageSourceType" />
                Static (uploaded image)
            </label>
            <label style="font-weight: 400;">
                <input type="radio" name="imageSourceType" [value]="SourceType.Dynamic" [(ngModel)]="imageSourceType" />
                Dynamic (newest gateway image)
            </label>
        </div>

        <div *ngIf="imageSourceType === SourceType.Static" style="margin-bottom: 12px;">
            <input type="file" accept="image/*" class="form-control" (change)="onFileSelected($event)" />
            <small *ngIf="isUpdate && imageFavorite?.blobName && selectedFile == null" class="text-muted">
                Leave empty to keep the current image.
            </small>
            <img *ngIf="previewSrc" [src]="previewSrc" alt="Preview" style="margin-top: 8px; max-width: 100%; max-height: 200px;" />
        </div>

        <div *ngIf="imageSourceType === SourceType.Dynamic" style="margin-bottom: 12px;">
            <div class="form-group" style="margin-bottom: 8px;">
                <label>Scoutview Gateway*</label>
                <ng-select [items]="gateways" bindLabel="name" bindValue="serialNumber" name="gatewaySourceId"
                           placeholder="Select Gateway" [(ngModel)]="gatewaySourceId">
                </ng-select>
            </div>
            <div class="form-group" style="margin-bottom: 0;">
                <label>Media Tag</label>
                <ng-select [items]="tagSuggestions" [addTag]="true" addTagText="Use tag" name="imageTag"
                           placeholder="Any tag (newest image)" [(ngModel)]="imageTag">
                </ng-select>
            </div>
            <small class="text-muted">Shows the gateway's newest image with this tag. The image and dynamic labels refresh every 5 minutes while displayed.</small>
        </div>

        <div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 15px;">
            <button type="button" class="btn btn-basic" (click)="cancel()">Cancel</button>
            <button type="button" class="btn btn-success" [disabled]="!canSave" (click)="save()">{{ isUpdate ? 'Update' : 'Create' }}</button>
        </div>
    </div>
</div>
